/** Canonical supported marketplaces — Amazon first (primary import lane). */
export const SUPPORTED_MARKETPLACES = [
  { id: 'amazon', name: 'Amazon', url: 'https://www.amazon.com', featured: true },
  { id: 'ebay', name: 'eBay', url: 'https://www.ebay.com' },
  { id: 'aliexpress', name: 'AliExpress', url: 'https://www.aliexpress.com' },
  { id: 'temu', name: 'TEMU', url: 'https://www.temu.com' },
  { id: 'shein', name: 'SHEIN', url: 'https://www.shein.com' },
  { id: 'walmart', name: 'Walmart', url: 'https://www.walmart.com' },
  { id: 'alibaba', name: 'Alibaba', url: 'https://www.alibaba.com' },
  { id: 'other', name: 'Other', url: null },
];

export const MARKETPLACE_IDS = SUPPORTED_MARKETPLACES.map((m) => m.id);

export function getMarketplaceById(id) {
  return SUPPORTED_MARKETPLACES.find((m) => m.id === id) ?? null;
}
